export const PROPOSAL_STATUS = {
    draft:    { label: 'Draft',    tone: 'bg-slate-100 text-slate-700 border-slate-200' },
    sent:     { label: 'Sent',     tone: 'bg-indigo-50 text-indigo-700 border-indigo-200' },
    viewed:   { label: 'Viewed',   tone: 'bg-sky-50 text-sky-700 border-sky-200' },
    accepted: { label: 'Accepted', tone: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
    rejected: { label: 'Rejected', tone: 'bg-red-50 text-red-700 border-red-200' },
    expired:  { label: 'Expired',  tone: 'bg-amber-50 text-amber-800 border-amber-200' },
};

export const PROPOSAL_STATUS_ORDER = ['draft', 'sent', 'viewed', 'accepted', 'rejected', 'expired'];

export const FREQUENCY_LABELS = {
    monthly: 'Monthly',
    quarterly: 'Quarterly',
    annually: 'Annually',
    annual_upfront: 'Annual upfront',
};

export const GBP = (v) => new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(v || 0));
export const GBP0 = (v) => new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0 }).format(Number(v || 0));
